import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from 'react';
import dynamic from 'next/dynamic';
import promosModule, { loadPromos } from './promosModule';
import { AdminGuard } from '@techstyle/react-admin';
var PromosAdminPanel = dynamic(() => import(
/* webpackChunkName: "AdminTools" */
'./PromosAdminPanel'));
var OneHourPromosExpire = dynamic(() => import(
/* webpackChunkName: "OneHourPromosExpire" */
'./OneHourPromosExpire'));
export default function promosExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultPromosReq = _ref.defaultPromosRequired,
      defaultPromosRequired = _ref$defaultPromosReq === void 0 ? false : _ref$defaultPromosReq,
      _ref$firstHourRefresh = _ref.firstHourRefresh,
      firstHourRefresh = _ref$firstHourRefresh === void 0 ? false : _ref$firstHourRefresh;

  return {
    id: 'promos',
    redux: {
      modules: [promosModule]
    },
    app: {
      render(props, children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(AdminGuard, null, /*#__PURE__*/React.createElement(PromosAdminPanel, null)), firstHourRefresh ? /*#__PURE__*/React.createElement(OneHourPromosExpire, null) : null);
      }

    },

    page(options) {
      var _options$promosRequir = options.promosRequired,
          promosRequired = _options$promosRequir === void 0 ? defaultPromosRequired : _options$promosRequir;
      return {
        getInitialProps(ctx) {
          return _asyncToGenerator(function* () {
            if (promosRequired) {
              yield ctx.store.dispatch(loadPromos());
            }
          })();
        }

      };
    }

  };
}